export const getDefaultAmount = (amounts) => {
  const filteredAmounts = amounts?.filter(
    (amount) => amount.is_default === true
  );
  const defaultAmount = filteredAmounts[0] ? filteredAmounts[0].amount : null;
  return defaultAmount;
};
